import assets from 'modules/assets'

export function largeQuote(data) {
  return {
    title: data['intro-a'],
    subTitle: {
      text: data['intro-b']
    },
    description: ['School', 'A global educational collective that builds spaces, experiences & tools to reclaim the magic of learning.'],
    quote1: {
      text: data['home-quote-one'],
      editStyle: true,
      words: ['mind', 'heart'],
      style: 'sectra'
    },
    quote2: {
      text: data['home-quote-two'],
      editStyle: true // adds spaces
    },
    author: data['quote-author']
  }
}

export function manifesto() {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Our Story']
        }
      ],
      [
        {
          type: 'p',
          content: 'What is the purpose of education? Where are the spaces where we can grow thoughtfully and collaboratively?'
        },
        {
          type: 'p',
          content: 'In search for such spaces, Gakko started in 2012 as an experimental summer camp in Japan. Since then, our summer camps have expanded to five countries, inviting dozens of mentors from around the world to share their passions through interdisciplinary workshops.'
        },
        {
          type: 'p',
          content: 'Today we are a full-time collective working on various educational projects, in both analog and digital spaces, to create meaningful learning environments.'
        },
        {
          type: 'h5',
          content: 'Read more of our story >>',
          linkURL: '/our-story'
        }
      ],
      [
        {
          type: 'h3',
          content: ['Gakko Camps']
        },
        {
          type: 'p',
          content: 'Interdisciplinary workshops, global mentorship. Held every summer in beautiful places. Designed from the ground up by inspiring mentors from around the world.'
        },
        {
          type: 'h5',
          content: 'Learn more >>',
          linkURL: '/camps'
        },
        {
          type: 'h3',
          content: ['Gakko Digital Learning']
        },
        {
          type: 'p',
          content: 'Smarter data collection and personalized curriculum. We’re developing technology to make “schooling” more accessible and efficient for all.'
        },
        {
          type: 'h5',
          content: 'Learn more >>',
          linkURL: '/digital'
        },
        {
          type: 'h3',
          content: ['Gakko New York']
        },
        {
          type: 'p',
          content: '10 weeks. Build an App or record an Album. At Gakko New York, high schoolers will have the opportunity to study technology or music at an unprecedented afterschool program.'
        },
        {
          type: 'h5',
          content: 'Learn more >>',
          linkURL: '/newyork'
        }
      ]
    ]
  }
}

export function links() {
  // Feeds into RowThreeBlock
  return {
    title: 'The Latest',
    content: [
      {
        linkURL: 'http://www.inktalks.com/discover/868/bringing-magic-into-education',
        style: 'grid-small spotlight-link',
        title: 'Watch Kenta\'s talk at INK Goa >>',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/spotlight/spotlight_1.jpg'),
          style: ''
        }
      },
      {
        linkURL: 'https://vimeo.com/156517062',
        style: 'grid-small grid-middle spotlight-link',
        title: 'I Was A Kohai Series: Makoto Shinzo >>',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/spotlight/spotlight_3.jpg'),
          style: ''
        }
      },
      {
        linkURL: 'https://gakkoproject.us4.list-manage.com/subscribe/post?u=fa4319fecd8b40e74b6a3ee7b&id=477d0e625d',
        style: 'grid-small spotlight-link',
        title: 'Subscribe to our newsletter >>',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/get-involved/contact.jpg'),
          style: ''
        }
      }
    ]
  }
}

export function team() {
  // Feeds into RowThreeText
  return {
    large: true,
    content: [
      [
        {
          type: 'h3',
          content: ['The Team']
        }
      ],
      [
        {
          type: 'h2',
          content: ['We\'re a team of engineers, designers, artists and architects based in Tokyo & San Francisco.']
        },
        {
          type: 'h5',
          content: 'Meet the team >>',
          linkURL: '/our-story#team'
        }
      ]
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/home.js